import { Component } from '@angular/core';
import { FormsModule, Validators, NgForm } from '@angular/forms';
import { AgencyService } from '../_Services/agency.service';
import { Router, ActivatedRoute } from '@angular/router'; 

@Component({
  templateUrl: 'adduser.component.html' 
})
export class AdduserComponent {

  	model: any = {};
    responseStatus:Object= [];
    status:boolean;
    agency_id: Number;
    error = '';

	constructor(private router: Router, private route:ActivatedRoute, private agencyService: AgencyService) { }

	onSubmit() {
		console.log(this.model);
		this.agencyService.addAgencyUser(this.model, this.agency_id).subscribe(result => {
            if (result.status === true) {
                this.router.navigate(['/agencies/users']);
            } else {
                this.error = 'Username or password is incorrect'; 
            }
        }); 
	}

	ngOnInit() { 
	    this.agency_id = this.route.snapshot.params['id'];
	}

}



// WEBPACK FOOTER //
// ./src/app/agencies/adduser.component.ts